'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import UIFlex from 'UIComponents/layout/UIFlex';

const ErrorPanelBody = () => /*#__PURE__*/_jsx(UIDialogBody, {
  children: /*#__PURE__*/_jsx(UIFlex, {
    direction: "column",
    justify: "around",
    style: {
      height: '100%'
    },
    children: /*#__PURE__*/_jsx(UIErrorMessage, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "errors.genericError"
      })
    })
  })
});

export default ErrorPanelBody;